import React, {useEffect, useMemo, useState} from "react";
import MobileDetect from "mobile-detect";
import {Button} from "@mui/material";
import {Dialog} from "~/components/Dialog";
import {Box} from "@mui/system";


export type DeviceSupportWarningProps = {
}


function useShowDeviceSupportWarning() {
    const storeKey = "device-support-warning-rejected";
    const rejected = sessionStorage.getItem(storeKey) == "true";

    const isMobile = useMemo(() => {
        return typeof window != "undefined" && new MobileDetect(window.navigator.userAgent).mobile();
    }, []);

    const reject = () => {
        sessionStorage.setItem(storeKey, "true")
    }

    return {reject, show: !rejected && !isMobile};
}


export const DeviceSupportWarning = (props: DeviceSupportWarningProps) => {
    const {reject, show} = useShowDeviceSupportWarning();
    const [open, setOpen] = useState(false);
    const handleContinueClick = () => {
        setOpen(false);
        reject();

    }

    const handleClose = () => {
        reject();
    }

    useEffect(() => {
        if (show) {
            setOpen(true);
        }
    }, [show]);


    return (
        <Dialog
            debug
            open={open}
            onClose={handleClose}
            title="Ваше устройство не поддерживается"
            actions={
                <Box maxWidth={140}>
                    <Button size="small" fullWidth color="additionalPrimary" onClick={handleContinueClick}>
                        Продолжить
                    </Button>
                </Box>
            }
        >
            Возможна некорректная работа ресурса. Данный ресурс предназначен для мобильных устройств
        </Dialog>
    )
}
